import React, {useState} from 'react'
import OrderStep from "./OrderStep";
import {Checkbox, Container, Form, Input, Card, Segment, Image, Icon, Dimmer, Loader, Divider} from 'semantic-ui-react';
import BillCard from "./bill-card";
import {Button,Message} from 'semantic-ui-react';
import {API_BASE} from "../config/env";
import axios from "axios";
import PropTypes from "prop-types";
import { Link } from 'react-router-dom'

import styles from './OrderPayment.module.css'
import Helper from "./Helper";

function OrderPaymentDetail(props){
    OrderPaymentDetail.propTypes = {
        prev: PropTypes.func,
        next: PropTypes.func,
        selectPaymentMethod: PropTypes.func,
        changeValidatedStatus: PropTypes.func,
    };

    const [otpPin, setOtpPin] = useState('');
    const [validationToken, setValidationToken] = useState('');
    const [renderOtpPanel, setRenderOtpPanel] = useState(false);
    const [renderCardDivider, setRenderCardDivider] = useState(false);
    const [disableSendOtpButton, setDisableSendOtpButton] = useState(false);
    const [serviceMessage, setServiceMessage] = useState('');
    const [messageOpen, setMessageOpen] = useState(false);
    const [cardNotFoundOpen, setCardNotFoundOpen] = useState(false);
    const [disableValidateOtpButton, setDisableValidateOtpButton] = useState(false);
    const [cardList,setCardList] = useState([]);
    const [selectedCard, setSelectedCard] = useState();
    const [sendOtpProcessActive, setSendOtpProcessActive] = useState(false);
    const [validateOtpProcessActive, setValidateOtpProcessActive] = useState(false);
    const [getCardsProcessActive,setGetCardsProcessActive] = useState(false);
    const {getTrackingId} = Helper();

    const handleOtpPinChange=(e)=> {
        if (messageOpen){
            setMessageOpen(false);
        }
        setOtpPin(e.target.value)
    }

    const sendOtpFnc = async (e) => {
        setSendOtpProcessActive(true);
        e.preventDefault();
        const result = await sendOtp(props.msisdn);
        if (result.operationResult.resultCode === "0") {
            setValidationToken(result.validationToken);
            setRenderOtpPanel(true);
            setDisableSendOtpButton(true)
        } else {
            setServiceMessage(result.operationResult.resultDesc);
            setMessageOpen(true);
            setRenderOtpPanel(false);
        }
        setSendOtpProcessActive(false);
    };

    const sendOtp = async (msisdn) => {
        let databody = {
            msisdn: msisdn,
            trackingId:getTrackingId()
        };
        try {
            const response = await axios
                .post(`${API_BASE}/sendOtp`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                return response.data;
            }
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    const validateOtpFnc = async (e) => {
        setValidateOtpProcessActive(true);
        e.preventDefault();
        const result = await validateOtpAndGetCards(props.msisdn, otpPin,validationToken);
        setValidateOtpProcessActive(false);
        if (result.operationResult.resultCode === "0") {
            setDisableValidateOtpButton(true);
            setRenderCardDivider(true);
            //props.changeValidatedStatus(true);
            if ( result.paymentMethodList != null &&  result.paymentMethodList.length>0){
                setCardList(result.paymentMethodList);
            } else {
                setCardNotFoundOpen(true);
            }

        } else {
            setServiceMessage(result.operationResult.resultDesc);
            setMessageOpen(true);
        }
    };

    const validateOtpAndGetCards = async (msisdn, otpPin, validationToken) => {
        let databody = {
            validationToken: validationToken,
            otpValue: otpPin,
            msisdn: msisdn,
            trackingId:getTrackingId()
        };
        try {
            const response = await axios
                .post(`${API_BASE}/validateOtpAndGetSavedCards`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                return response.data;
            }
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    const validateOtp = async (msisdn, otpPin, validationToken) => {
        let databody = {
            validationToken: validationToken,
            otpValue: otpPin,
            msisdn: msisdn,
            trackingId:getTrackingId()
        };
        try {
            const response = await axios
                .post(`${API_BASE}/validateOtp`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                return response.data;
            }
        } catch (err) {
            console.error(err);
            return false;
        }
    };

    const getSavedCards = async (msisdn, otpPin, validationToken) => {
        let databody = {
            validationToken: validationToken,
            otpValue: otpPin,
            msisdn: msisdn,
            trackingId:getTrackingId()
        };
        try {
            const response = await axios
                .post(`${API_BASE}/getPaymentMethods`, databody)
                .catch((error) => console.log(error));
            if (response.status === 200) {
                return response.data;
            }
        } catch (err) {
            console.error(err);
            return false;
        }
    };
    const selectCard =(e,card)=> {
        e.preventDefault();
        setSelectedCard(card);
        props.selectPaymentMethod(card);
        props.next();
    }

    const linkkkk =  () => {
        return <> Fatura ödeme talimatı verebilmek için Paycell müşterisi olmanız gerekmektedir.
            Paycell müşterisi olmak için
            <a target='_blank' href='https://paycell.com.tr/app-redirect'> linke </a>
            tıklayarak kaydınızı kolayca yapabilirsiniz. </>
    }

    return (
        <React.Fragment>
            <Dimmer active={sendOtpProcessActive} inverted>
                <Loader inverted>Tek Kullanımlık Şifre Gönderiliyor...</Loader>
            </Dimmer>
            <Dimmer active={validateOtpProcessActive} inverted>
                <Loader inverted>Tek Kullanımlık Şifre Doğrulanıyor...</Loader>
            </Dimmer>
            <Dimmer active={getCardsProcessActive} inverted>
                <Loader inverted>Kayıtlı Kartlar Getiriliyor...</Loader>
            </Dimmer>

            <Form widths='equal' >
                <Form.Field
                    control={Input}
                    label='Telefon Numarası'
                    value={props.msisdn}
                    name="msisdn"
                />
                <Button onClick={sendOtpFnc} disabled={disableSendOtpButton}>Doğrulama Kodu Gönder</Button>
                <br/>
                {renderOtpPanel == true ? (
                    <Form>
                        {messageOpen == true ? (
                            <h5 style={{color:'red'}}>{serviceMessage}</h5>
                        ) : (<h1></h1>)
                        }
                        <Form.Input
                            style={{width:'150px'}}
                            control={Input}
                            type='password'
                            label='SMS Şifresi'
                            value={otpPin}
                            name="otpPin"
                            maxLength='4'
                            onChange={handleOtpPinChange}
                            disabled={disableValidateOtpButton}
                        />
                        <Button onClick={validateOtpFnc} disabled={disableValidateOtpButton}>Doğrula</Button>
                    </Form>) : (<h1></h1>)

                }
                <br/>
                {renderCardDivider == true ? (
                    <Divider horizontal>PAYCELL CÜZDANDA KAYITLI KARTLARIM</Divider>) : (<p></p>)
                }
                <br/>
                <div style={{display: 'grid',
                justifyContent:'space-evenly'}}>
                    <Card.Group>
                        {
                            cardList.length > 0 ? (
                                cardList.map((card) => (
                                <Card key={card.paymentMethodID} className={styles.card}>
                                    <Card.Content>
                                        <Image floated='right'>
                                            <Icon name='credit card outline' size='big' />
                                        </Image>
                                        <Card.Header>{card.alias}</Card.Header>
                                        <Card.Meta>{card.paymentCardNumber}</Card.Meta>
                                    </Card.Content>
                                    <Card.Content extra>
                                        <div className='ui two buttons'>
                                            <Button toggle onClick={(e) => selectCard(e,card)}>
                                                Seç
                                            </Button>
                                        </div>
                                    </Card.Content>
                                </Card>
                            ))
                            ) : (
                                    cardNotFoundOpen ? (

                                            <Message
                                                icon='credit card outline'
                                                header='Kayıtlı Kart Bulunamadı.'
                                                content={linkkkk}
                                                />
                                    ) : ( <p></p> )

                            )

                        }
                        {renderCardDivider == true ? (
                            <Message size='mini'>Paycell cüzdanına kart eklemek için
                                <a target='_blank' href='https://paycell.com.tr/app-redirect'> Paycell </a>
                                uygulamasını kullanabilirsin.</Message>) : (<p></p>)
                        }
                    </Card.Group>
                </div>
            </Form>
            <br/>
            <br/>
            <Button onClick={props.prev}>Geri</Button>
            <Button onClick={props.close} floated='right' >Vazgeç</Button>
        </React.Fragment>
    )
}

export default OrderPaymentDetail;